var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileContract(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M576 272V0H176C149.4 0 128 21.4 128 48v928c0 26.6 21.4 48 48 48h672c26.6 0 48-21.4 48-48V320H624c-26.4 0-48-21.6-48-48zM256 144c0-8.84 7.16-16 16-16h160c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H272c-8.84 0-16-7.16-16-16V144z m0 128c0-8.84 7.16-16 16-16h160c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H272c-8.84 0-16-7.16-16-16v-32z m385.62 496H736c17.68 0 32 14.32 32 32s-14.32 32-32 32h-94.38c-32.9 0-62.54-18.28-77.28-47.72-5.9-11.84-16.18-13.04-20.34-13.04s-14.44 1.18-20.04 12.38l-15.34 30.68a31.972 31.972 0 0 1-28.62 17.68c-0.76 0-1.5-0.04-2.28-0.1-12.9-0.9-24-9.5-28.06-21.78L416 709.18l-21.22 63.76c-11.78 35.32-44.76 59.06-82 59.06H288c-17.68 0-32-14.32-32-32s14.32-32 32-32h24.78c9.66 0 18.22-6.16 21.28-15.32l36.38-109.28c6.6-19.62 24.88-32.82 45.56-32.82s38.96 13.18 45.54 32.82l27.76 83.28c39.54-32.38 108.1-19.4 132 28.32 4.04 8.12 11.92 13 20.32 13zM882 210L686.2 14c-9-9-21.2-14-34-14H640v256h256v-12.2c0-12.6-5-24.8-14-33.8z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileContract);
export default __webpack_public_path__ + "static/media/file-contract.273d99dcf1cdcc0585c73d73361a0aba.svg";
export { ForwardRef as ReactComponent };